import { getToken } from '@/utils/auth'

// 登录页面
const loginPage = "/pages/login"
  
// 页面白名单
const whiteList = [
  '/pages/login', '/pages/register', '/pages/common/webview/index','/pages/vip/register'
]
uni.addInterceptor('request', {
  success(args) {
    // 在请求发送前处理
    // const path = args.url;
    // const allowedPaths = ['/pages/vip/register']; 
    // if (!allowedPaths.includes(path)) {
      // 请求成功后处理
	    // console.log("args.header:"+args.header)
  console.log('Response:', args);
  const responseHeaders = args.header;
  const token = responseHeaders['Authorization'] || responseHeaders['authorization'];
  if (token) {
	console.log('Authorization token from response:', token);
	setToken(token)
  } else {
	console.log('No Authorization token found in response');
  }
    // }

  },
  fail(err) {
    // 请求失败后处理
  },
  complete(args) {
    // 请求完成后处理
  }
});
// 检查地址白名单
// function checkWhite(url) {
//   const path = url.split('?')[0]
//   return whiteList.indexOf(path) !== -1
// }

// // 页面跳转验证拦截器
// let list = ["navigateTo", "redirectTo", "reLaunch", "switchTab"]
// list.forEach(item => {
//   uni.addInterceptor(item, {
//     invoke(to) {
//       if (getToken()) {
//         if (to.url === loginPage) {
//           uni.reLaunch({ url: "/" })
//         }
//         return true
//       } else {
//         if (checkWhite(to.url)) {
//           return true
//         }
//         uni.reLaunch({ url: loginPage })
//         return false
//       }
//     },
//     fail(err) {
//       console.log(err)
//     }
//   })
// })



// uni.addInterceptor('request', {
//   invoke(args) {
//     // 在请求发送前处理
//     const path = args.url;
//     limitPath = '#/pages/vip/register'
//     const pathRegex = /^\/your-allowed-path\d+$/; // 添加你的正则表达式

//     if (!pathRegex.test(path)) {
//       console.log('Path not allowed:', path);
//       // 你可以选择在这里终止请求或进行其他处理
//       return false; // 终止请求
//     }
//   },
//   success(args) {
//     // 请求成功后处理
//     const responseHeaders = args.header;
//     const token = responseHeaders['Authorization'] || responseHeaders['authorization'];
//     if (token) {
//       console.log('Authorization token from response:', token);
//       setToken(token)
//     } else {
//       console.log('No Authorization token found in response');
//     }
//   },
//   fail(err) {
//     // 请求失败后处理
//   },
//   complete(args) {
//     // 请求完成后处理
//   }
// });
